import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full pt-10 pb-24 px-6 md:px-12 flex flex-col items-center text-center" data-id="element-16">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto space-y-8" data-id="element-17">
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-[#f0f0f0] leading-[1.1]" data-id="element-18">
          Deja de usar ChatGPT <br className="hidden md:block" data-id="element-19" />
          como juguete.
        </h1>

        <p className="text-xl md:text-2xl text-[#00d4aa] font-medium tracking-wide" data-id="element-20">
          3 asistentes. 72 horas. Cero código.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.3,
      duration: 0.8
    }} className="mt-16 mb-20 w-full max-w-2xl mx-auto shadow-2xl shadow-[#00d4aa]/10 rounded-lg overflow-hidden" data-id="element-21">
        <img src="https://cdn.magicpatterns.com/uploads/jNp7tKv6MPpRo4jwsEy1ug/heylloyd-image-1770673918721.png" alt="Sistema Asistentes Listos Mockup" className="w-full h-auto object-cover" data-id="element-22" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-2xl mx-auto text-left space-y-6 text-lg md:text-xl text-gray-400 leading-relaxed font-light" data-id="element-23">
        <p data-id="element-24">Estás usando IA.</p>
        <p data-id="element-25">Pero sigues trabajando como si no existiera.</p>
        <p data-id="element-26">No porque seas "malo".</p>
        <p data-id="element-27">No porque "no seas técnico".</p>
        <p data-id="element-28">
          Sino porque te dieron lo único que abunda: prompts sueltos, teoría y
          ejemplos que no sobreviven a tu semana real.
        </p>

        <div className="py-4" data-id="element-29">
          <p className="font-medium text-white mb-2" data-id="element-30">
            Y cuando lo intentas en serio:
          </p>
          <ul className="list-disc pl-5 space-y-2 marker:text-[#00d4aa]" data-id="element-31">
            <li data-id="element-32">te devuelve texto correcto… pero genérico</li>
            <li data-id="element-33">te hace editar más de lo que te ahorra</li>
            <li data-id="element-34">terminas haciéndolo tú, otra vez</li>
          </ul>
        </div>

        <p className="text-white font-medium border-l-2 border-[#00d4aa] pl-6 py-2" data-id="element-35">
          Este producto existe para que en 72 horas tengas 3 asistentes con
          estándar (inputs, reglas, salidas y pruebas) que produzcan entregables
          repetibles: contenido, respuestas a leads y reporting.
        </p>
      </motion.div>
    </section>;
}